import React, { useContext, useEffect } from 'react';
import { ShopperContext } from '../context/shopper';
import { ErrorList } from './ErrorList';
import { useForm } from "../hooks/useForm";
import { useStyles } from "../hooks/useStyles";
import { useParams } from 'react-router-dom';
import { sumThese } from '../utils';
import { BackButton } from './BackButton';
import { HeadingBuilder } from './HeadingBuilder';
import { TripHeader } from './TripHeader';
import { NumericFormat } from 'react-number-format';
import { useTranslation } from "react-i18next";
import Table from 'react-bootstrap/Table';
import styles from '../css/trTdFirstChild.module.css';

export const TripSkuWeightEditForm = () => {
    const { signedIn, tripSkuWeights, editTripSkuWeight,
            trips,
            errorsDoExist, dismissErrorsList, setErrorsDoExistToFalse,
            setJustGotClearToFalse,
          } = useContext(ShopperContext);

    // console.log('tswef trips: ', tripSkuWeights)

    const {id} = useParams();
    console.log('tswef id: ', id)

    const { tableShow, tableData } = useStyles();
    const { t } = useTranslation();

    const tswObj = tripSkuWeights.find(tsw =>  tsw.id === id);
    console.log('tswef tswObj: ', tswObj)

    if (tswObj == null) {
      console.log('tswef tswObj2: ', tswObj)
      // User likely used browser to refresh the page, lost access to state.
      // This causes 'tswObj' to be 'undefined'.
      // Let's go back to the 'trips' page.
      window.location.replace('/trips/');
    }

    const tripObj = trips.find(t => t.id === tswObj.trip.id);
    console.log('tswef tripObj: ', tripObj)

    useEffect(() => {
      dismissErrorsList();
    }, [dismissErrorsList]);

    const initialState = {
      id:               tswObj.id,
      actual_weight_0:  tswObj.actual_weight_0,
      actual_weight_1:  tswObj.actual_weight_1,
      actual_weight_2:  tswObj.actual_weight_2,
      actual_weight_3:  tswObj.actual_weight_3,
      actual_weight_4:  tswObj.actual_weight_4,
    };
    console.log("tswef: initialState", initialState);

    const { formData, handleChange, handleValueChange, reset, editFormValues,
      } = useForm(initialState);

    const totalWeight = sumThese({nums: [
      +formData.actual_weight_0,
      +formData.actual_weight_1,
      +formData.actual_weight_2,
      +formData.actual_weight_3,
      +formData.actual_weight_4,
    ]}).toFixed(2).toString() + " " + tswObj.sku.units;

    if (signedIn) {
        const handleSubmit = (e) => {
            e.preventDefault();
        
            // clear out any error messages, success statuses
            dismissErrorsList();
            setErrorsDoExistToFalse();
            setJustGotClearToFalse();
        
            // console.log('formData for editTripSkuWeight: ', formData);
            editTripSkuWeight(formData);
        
            // If there is an error we want to preserve formData and show the message.
        }

        return (
          <article>
            <TripHeader
              trip = {tripObj}
            />
            <br/>
            <HeadingBuilder
              Size = 'h3'
              headingText = {t('tsw.formPart.inputActualWeights')}
              value = {`${tswObj.sku.label} (${tswObj.sku.units})`}
              // Input actual weight for: chicken breast sticks (kg)
            />
            <br/>
        <form onSubmit={handleSubmit}>
<Table responsive striped bordered hover size="sm" style={tableShow}>
  <thead >
  </thead>
  <tbody className={styles.trTdFC} style={tableData} >
    <tr>
      <td>
        <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('tsw.label.actualWeight0')}
          // First package:
          labelHtmlFor   = "aw0_label_tswef"
          tippyAlertText = {t('tsw.label.tippyContentA')}
          tippyText      = {t('tsw.label.tippyContentA')}
        />
      </td>
      <td>
        <NumericFormat displayType="input"
          key="10"
          type="text"
          id="aw0_tswef"
          name="actualWeight0"
          value={formData.actual_weight_0}
          decimalScale={2}
          allowNegative={false}
          onValueChange={handleValueChange("actual_weight_0")}
          required
        />
        &nbsp;*
      </td>
    </tr>
  {/* Show 'Second package' row if 'First package' row has non-zero value or
      this or a following row has a value. Similar for other 'package' rows. */}
  { (formData.actual_weight_0 > 0  ||  sumThese({nums: [
                                         +formData.actual_weight_1,
                                         +formData.actual_weight_2,
                                         +formData.actual_weight_3,
                                         +formData.actual_weight_4,
                                       ]}) > 0
    )
  ?
    <tr>
      <td>
        <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('tsw.label.actualWeight1')}
          // Second package:
          labelHtmlFor   = "aw1_label_tswef"
          tippyAlertText = {t('tsw.label.tippyContentB')}
          tippyText      = {t('tsw.label.tippyContentB')}
        />
      </td>
      <td>
        <NumericFormat displayType="input"
          key="20"
          type="text"
          id="aw1_tswef"
          name="actualWeight1"
          value={formData.actual_weight_1}
          decimalScale={2}
          allowNegative={false}
          onValueChange={handleValueChange("actual_weight_1")}
        />
        &nbsp;
      </td>
    </tr>
  : null
  }
  { (formData.actual_weight_1 > 0  ||  sumThese({nums: [
                                         +formData.actual_weight_2,
                                         +formData.actual_weight_3,
                                         +formData.actual_weight_4,
                                       ]}) > 0
    )
  ?
    <tr>
      <td>
        <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('tsw.label.actualWeight2')}
          // Third package:
          labelHtmlFor   = "aw2_label_tswef"
          tippyAlertText = {t('tsw.label.tippyContentB')}
          tippyText      = {t('tsw.label.tippyContentB')}
        />
      </td>
      <td>
        <NumericFormat displayType="input"
          key="30"
          type="text"
          id="aw2_tswef"
          name="actualWeight2"
          value={formData.actual_weight_2}
          decimalScale={2}
          allowNegative={false}
          onValueChange={handleValueChange("actual_weight_2")}
        />
        &nbsp;
      </td>
    </tr>
  : null
  }
  { (formData.actual_weight_2 > 0  ||  sumThese({nums: [
                                         +formData.actual_weight_3,
                                         +formData.actual_weight_4,
                                       ]}) > 0
    )
  ?
    <tr>
      <td>
        <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('tsw.label.actualWeight3')}
          // Fourth package:
          labelHtmlFor   = "aw3_label_tswef"
          tippyAlertText = {t('tsw.label.tippyContentB')}
          tippyText      = {t('tsw.label.tippyContentB')}
        />
      </td>
      <td>
        <NumericFormat displayType="input"
          key="40"
          type="text"
          id="aw3_tswef"
          name="actualWeight3"
          value={formData.actual_weight_3}
          decimalScale={2}
          allowNegative={false}
          onValueChange={handleValueChange("actual_weight_3")}
        />
        &nbsp;
      </td>
    </tr>
  : null
  }
  { (formData.actual_weight_3 > 0  ||  formData.actual_weight_4 > 0)
  ?
    <tr>
      <td>
        <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('tsw.label.actualWeight4')}
          // Fifth package:
          labelHtmlFor   = "aw4_label_tswef"
          tippyAlertText = {t('tsw.label.tippyContentB')}
          tippyText      = {t('tsw.label.tippyContentB')}
        />
      </td>
      <td>
        <NumericFormat displayType="input"
          key="50"
          type="text"
          id="aw4_tswef"
          name="actualWeight4"
          value={formData.actual_weight_4}
          decimalScale={2}
          allowNegative={false}
          onValueChange={handleValueChange("actual_weight_4")}
        />
        &nbsp;
      </td>
    </tr>
  : null
  }
    <tr>
      <td>
        <HeadingBuilder
          containerType  = "container-hug-bottom-right"
          headingText    = {t('tsw.label.totalWeight')}
          // Total weight:
          tippyAlertText = {t('tsw.totalWeight.tippyContent')}
          tippyText      = {t('tsw.totalWeight.tippyContent')}
        />
      </td>
      <td>
        <HeadingBuilder
          containerType  = "container-hug-bottom-left"
          headingText    = {totalWeight}
          // 13.04 lb
        />
      </td>
    </tr>
  </tbody>
</Table>
        {/* TODO: ?Will translating Submit be handled automatically by html?
            https://www.w3.org/International/wiki/Locale-based_forms */}
          <input key="170" type='submit' value='Submit' />
        </form>
        { errorsDoExist && <ErrorList /> }
        <BackButton />
      </article>
     )
    } else {
      return (
        <HeadingBuilder
          Size = 'h3'
          headingText = {t('global.notSignedInMessage')}
          // Not Authorized - Please Sign in or Sign up
        />
      )
    }
}

export default TripSkuWeightEditForm;